
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class PDCClearanceDetailsDialog extends _Ext.EditorDialogBase<PDCClearanceDetailsRow> {
        protected getFormKey() { return PDCClearanceDetailsForm.formKey; }
        //protected getIdProperty() { return PDCClearanceDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return PDCClearanceDetailsRow.localTextPrefix; }
       // protected getNameProperty() { return PDCClearanceDetailsRow.nameProperty; }
       // protected getService() { return PDCClearanceDetailsService.baseUrl; }
        protected getDeletePermission() { return PDCClearanceDetailsRow.deletePermission; }
        protected getInsertPermission() { return PDCClearanceDetailsRow.insertPermission; }
        protected getUpdatePermission() { return PDCClearanceDetailsRow.updatePermission; }

        protected form = new PDCClearanceDetailsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
    }
}